import * as Popover from '@radix-ui/react-popover';
import styled from 'styled-components';

export const StyledButton = styled(Popover.Trigger)`
	padding: 0.25rem 0.5rem;

	border-radius: 8px;

	&:hover,
	&[data-state='open'] {
		background-color: var(--surface-accent-light);
	}

	label {
		cursor: pointer;
		white-space: nowrap;
	}
`;
